var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alarm-queue',{scopedSlots:_vm._u([{key:"icons",fn:function(slotProps){return [_c('span',{staticClass:"fas fa-bell icon-label",class:{
				'text-danger': slotProps.eventQueue.awaitingRestoreCount > 0,
				'text-muted': slotProps.eventQueue.awaitingRestoreCount == 0
			},attrs:{"title":'Awaiting ' + slotProps.eventQueue.awaitingRestoreCount + ' restores'}}),_c('span',[_c('reset-actions-ccure',{attrs:{"event":slotProps.eventQueue}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }